"use client";

import { IProductDetails } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { useEffect } from "react";

const useRobosize = ({ product }: { product: IProductDetails }) => {
  const { robosize_domain, robosize_id, id } = product ?? {};
  useEffect(() => {
    if (!Boolean(robosize_domain && robosize_id)) return;

    (window as any).Robosize = (window as any).Robosize || {};
    (window as any).Robosize.shop = robosize_domain;
    (window as any).Robosize.product = id;

    const t = document.createElement("link");
    t.setAttribute(
      "href",
      "https://d3elw2t9mvtwj8.cloudfront.net/app_bundle.css",
    );
    t.setAttribute("id", "if-css");
    t.setAttribute("rel", "stylesheet");
    t.setAttribute("type", "text/css");
    document.body.insertBefore(t, document.body.firstChild);
    const e = document.createElement("script");
    e.setAttribute("id", "if-script");
    e.setAttribute(
      "src",
      "https://d3elw2t9mvtwj8.cloudfront.net/app_bundle.js",
    );
    document.head.insertBefore(e, document.head.firstChild);
    return () => {
      const t = document.getElementById("if-css");
      const e = document.getElementById("if-script");
      if (t) {
        t.remove();
      }
      if (e) {
        e.remove();
      }
    };
  }, [product]);
};

export default useRobosize;
